module.exports = __webpack_public_path__ + "img/MX.b9fb2f9e.svg";